import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import styled from 'styled-components';
import CommonTable from 'components/CommonTable';
import { CustomButton } from 'components/CustomForm';
import useModal from 'hooks/useModal';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import AddCoroporationModal from './AddCorporationModal';
import { getCorporations, deleteCoroporation } from 'network/apis/CorporationApi';
import { Spinner } from 'react-bootstrap';
import { TbEditCircle } from 'react-icons/tb';
import { TiDocumentDelete } from 'react-icons/ti';
import { PersianDate } from 'helpers/dates';
import CommonPrompt from "components/DeletePrompt";

const cols = [
	'حذف',
	'ویرایش',	
	// 'تاریخچه فعالیت ها',	
	'شماره تماس مدیر عامل',
	'نام و نام خانوادگی مدیر عامل',
	'نام شرکت',
	'ردیف'
];

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.loading {
		min-height: 30rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
	}

	div.header-card {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;

		button {
			width: 10rem;
		}
	}
`;

const CompaniesManagementTab = ({ currentTab = 'companies-management' }) => {	
	const {
		isOpen,
		handleOpenModal,
		handleCloseModal,
		data: editData,
	} = useModal();
	const {
		isOpen: isDeleteModalOpen,
		handleOpenModal: handleOpenDeleteModal,
		handleCloseModal: handleCloseDeleteModel,
		data: deleteModalData,
	} = useModal();

	const {
		data: coroporationsData,
		refetch,
		isLoading,
	} = useQuery(["province-get-corporations"], () => getCorporations(), {
		refetchOnWindowFocus: false,
		enabled: currentTab === 'companies-management'
	});

	const deleteMutation = useMutation(deleteCoroporation, {
		onSuccess: (res) => {
			if (res && res.status === 204) {
				toast(`با موفقیت حذف گردید`, {
					type: "success",
					position: "bottom-right",
				});
				refetch();
			}
		},
		onError: () => {
			toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
				type: "error",
				position: "bottom-right",
			});
		},
	});

	return (
		<Holder>
			{isLoading ? (
				<div className="loading">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				<Fragment>
					<div className="header-card">
						<CustomButton onClick={() => handleOpenModal(null)}>
							افزودن شرکت تعاونی
						</CustomButton>
					</div>
					<CommonTable cols={cols}>
						{coroporationsData?.data?.map((item, index) => (
							<tr key={`${item?.coop_id}`}>
								<td>
									<TiDocumentDelete
										onClick={() => {
											handleOpenDeleteModal(item);
										}}
									/>
								</td>
								<td>
									<TbEditCircle onClick={() => {
										  handleOpenModal(item);
									}} />
								</td>
								{/* <td className="d-flex align-items-center justify-content-center">
									<CustomButton
										onClick={() => {}}
										color='#0278EE'
										fontSize={10}
									>
										نمایش
									</CustomButton>
								</td>								 */}
								<td>{item.ceo_phone_number}</td>
								<td>{item.ceo_name}</td>
								<td>{item.name}</td>
								<td>{index + 1}</td>
							</tr>
						))}
					</CommonTable>
				</Fragment>
			)}
			{isOpen && (
				<AddCoroporationModal
					isOpen
					onClose={handleCloseModal}
					data={editData}
					onCreateSuccess={refetch}
				/>
			)}
			{isDeleteModalOpen && (
				<CommonPrompt
					isOpen={isDeleteModalOpen}
					onClose={handleCloseDeleteModel}
					onActionTap={() => {
						handleCloseDeleteModel();
						deleteMutation.mutate({ id: deleteModalData?.id });
					}}
				/>
			)}
		</Holder>
	);
};

export default CompaniesManagementTab;
